import React, { useState } from 'react'

import * as S from './InputNumberItem.styles'
import minIcon from './assets/min.svg'
import maxIcon from './assets/max.svg'
import { TInputNumber } from '../../types'


const InputNumberItem: React.FC<TInputNumber> = ({ name, value = 0, onChange, min = 0, max = 1000, className, id }) => {
  const [inputValue, setInputValue] = useState(value)

  const handleOnClick = (i: number): React.MouseEventHandler<HTMLButtonElement> => (event) => {
    event.preventDefault()
    const newValue = getValue(inputValue + i)

    setInputValue(newValue)
    onChange && onChange(name, newValue)
  }

  const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const value = event.target.value

    setInputValue(~~value)
    onChange && onChange(name, ~~value)
  }

  const handleOnBlur: React.FocusEventHandler<HTMLInputElement> = (event) => {
    const val = getValue(parseInt(event.target.value))

    setInputValue(val)
    onChange && onChange(name, ~~value)
  }

  const getValue = (value: number) => {
    if (!value) {
      return 0
    }

    if (value < min) {
      return min
    }

    if (value > max) {
      return max
    }

    return value
  }

  return (
    <S.InputNumber>
      <S.Button
        className={className}
        id={`less_${id}`}
        data-testid={`remove-button-${name}`}
        onClick={handleOnClick(-1)}
        disabled={min >= inputValue}
      >
        <img src={minIcon} alt='Diminuir quantidade' />
      </S.Button>
      <S.Input data-testid='input' name={name} type='number' onChange={handleOnChange} onBlur={handleOnBlur} value={inputValue} />
      <S.Button
        className={className}
        id={`plus_${id}`}
        data-testid={`add-button-${name}`}
        onClick={handleOnClick(1)}
        disabled={max <= inputValue}
      >
        <img src={maxIcon} alt='Aumentar quantidade' />
      </S.Button>
    </S.InputNumber>
  )
}

export default InputNumberItem
